import React from 'react';

export interface ErrorMessageProps {
  error?: Error;
}

// For displaying errors within pages
export const ErrorMessage = (props: ErrorMessageProps) => {
  const defaultMessage = 'An error occurred and has been logged.';
  return (
    <div data-testid="error-message" className="alert alert-danger">
      {props.error?.message || defaultMessage}
    </div>
  );
};
